module.exports = __webpack_public_path__ + "img/onEmission.3b73ddbc.png";